import React from 'react';
import {FormFieldProps} from '../../../@types/components/Form';
import Input from './Input';
import {IEmptyModel} from '../../../@interfaces/IEmptyModel';

export default function NumberField<Model extends IEmptyModel>(props: FormFieldProps<Model>) {
    return <Input
            {...props}
            type="number"
            min={props.config.min ?? undefined}
            max={props.config.max ?? undefined}
            step={props.config.step ?? undefined}
    />;
}
